import { RoutesService, eLayoutType } from '@abpdz/ng.core';
import { eThemeSharedRouteNames } from '@abpdz/ng.theme.shared';
import { APP_INITIALIZER } from '@angular/core';
import { eEzynessAdminPolicyNames } from './enums/policy-names';
import {
  eEzynessAdminRouteNames,
  eEzynessAdminRoutePaths,
} from './enums/route-names';

export const EZYNESSADMIN_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService],
    multi: true,
  },
];

function configureRoutes(routes: RoutesService): any {
  return () => {
    routes.add([
      {
        path: `/${eEzynessAdminRoutePaths.Root}/${eEzynessAdminRoutePaths.Commission}`,
        parentName: eThemeSharedRouteNames.Administration,
        name: eEzynessAdminRouteNames.Commission,
        requiredPolicy: eEzynessAdminPolicyNames.Commission,
        iconClass: 'money',
        order: 10,
        layout: eLayoutType.application,
      },
      {
        path: `/${eEzynessAdminRoutePaths.Root}/${eEzynessAdminRoutePaths.Credit_Card}`,
        parentName: eThemeSharedRouteNames.Administration,
        name: eEzynessAdminRouteNames.Credit_Card,

        requiredPolicy: eEzynessAdminPolicyNames.Commission,
        iconClass: 'money',
        order: 10,
        layout: eLayoutType.application,
      },
      {
        path: `/${eEzynessAdminRoutePaths.Root}/${eEzynessAdminRoutePaths.HOOKS}`,
        parentName: eThemeSharedRouteNames.Administration,
        name: eEzynessAdminRouteNames.Hooks,
        requiredPolicy: eEzynessAdminPolicyNames.Hooks,
        iconClass: 'event',
        order: 40,
        layout: eLayoutType.application,
      },
      {
        path: `/${eEzynessAdminRoutePaths.Root}/${eEzynessAdminRoutePaths.Config}`,
        parentName: eThemeSharedRouteNames.Administration,
        name: eEzynessAdminRouteNames.Config,
        requiredPolicy:
          eEzynessAdminPolicyNames.FluxConnectionConfig +
          ' || ' +
          eEzynessAdminPolicyNames.EzynessConnectionConfig,
        iconClass: 'settings_input_component',
        order: 50,
        layout: eLayoutType.application,
      },
      // {
      //   path: `/${eEzynessAdminRoutePaths.Root}/${eEzynessAdminRoutePaths.Reporting}`,
      //   parentName: eThemeSharedRouteNames.Administration,
      //   name: 'Analytics',
      //   requiredPolicy: eEzynessAdminPolicyNames.Reporting,
      //   iconClass: 'assignment',
      //   order: 55,
      //   layout: eLayoutType.application,
      // },
      {
        path: `/${eEzynessAdminRoutePaths.Root}/${eEzynessAdminRoutePaths.Fake}`,
        parentName: eThemeSharedRouteNames.Administration,
        name: 'Données de test',
        requiredPolicy: eEzynessAdminPolicyNames.Fake,
        iconClass: 'money',
        order: 60,
        layout: eLayoutType.application,
      },
    ]);
  };
}
